"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTemplateDishGroup = addTemplateDishGroup;
exports.applyDraft = applyDraft;
exports.batchAddTemplateDishGroup = batchAddTemplateDishGroup;
exports.batchChangeStatus = batchChangeStatus;
exports.cacheById = cacheById;
exports.changeApplyStore = changeApplyStore;
exports.checkApplyStore = checkApplyStore;
exports.checkTemplateTime = checkTemplateTime;
exports.copyTemplate = copyTemplate;
exports.copyTemplateDraft = copyTemplateDraft;
exports.createGroupSortConfig = createGroupSortConfig;
exports.deleteById = deleteById;
exports.deleteGroupItem = deleteGroupItem;
exports.deleteGroupSortConfig = deleteGroupSortConfig;
exports.deleteTemplateDishGroup = deleteTemplateDishGroup;
exports.downloadAllStoreQrCodes = downloadAllStoreQrCodes;
exports.generateMenuPreviewQrCode = generateMenuPreviewQrCode;
exports.getApplyStore = getApplyStore;
exports.getById = getById;
exports.getDefaultGroupSort = getDefaultGroupSort;
exports.getGroupItemDetails = getGroupItemDetails;
exports.getGroupSortList = getGroupSortList;
exports.getTemplateDishGroup = getTemplateDishGroup;
exports.getTemplateGroupItems = getTemplateGroupItems;
exports.getTemplateGroupsWithItemIds = getTemplateGroupsWithItemIds;
exports.queryList = queryList;
exports.save = save;
exports.saveGroupItem = saveGroupItem;
exports.saveGroupItemSort = saveGroupItemSort;
exports.saveGroupSort = saveGroupSort;
exports.saveGroupSortConfig = saveGroupSortConfig;
exports.syncMenu = syncMenu;
exports.syncStatusToStores = syncStatusToStores;
exports.updateGroupSortConfig = updateGroupSortConfig;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 缓存菜单
function cacheById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/cacheById/' + id,
    method: 'get'
  });
}

//实际执行应用到门店菜单
function changeApplyStore(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/changeApplyStore',
    method: 'post',
    data: data
  });
}

//验证当前勾选门店会造成的影响
function checkApplyStore(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/checkApplyStore',
    method: 'post',
    data: data
  });
}

//验证分时模板时间和星期更改的影响
function checkTemplateTime(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/checkTemplateTime',
    method: 'post',
    data: data
  });
}

//获取当前模板应用的门店列表
function getApplyStore(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/getApplyStore',
    method: 'post',
    data: data
  });
}

// 同步菜单
function syncMenu(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/syncMenu',
    method: 'post',
    data: data
  });
}

// 更新分组明细排序
function saveGroupItemSort(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/saveGroupItemSort',
    method: 'post',
    data: data
  });
}

// 更新分组排序
function saveGroupSort(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/saveGroupSort',
    method: 'post',
    data: data
  });
}

// 批量更新状态
function batchChangeStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/batchChangeStatus',
    method: 'post',
    data: data
  });
}

// 删除分组明细
function deleteGroupItem(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/deleteGroupItem?id=' + id,
    method: 'get'
  });
}

// 保存分组明细
function saveGroupItem(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/saveGroupItem',
    method: 'post',
    data: data
  });
}

// 获取模板关联的分组列表
function getTemplateGroupItems(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/getTemplateGroupItems',
    method: 'get',
    params: query
  });
}

// 获取分组列表及商品ID列表（轻量级，用于首次加载）
function getTemplateGroupsWithItemIds(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/getTemplateGroupsWithItemIds',
    method: 'get',
    params: query
  });
}

// 按分组ID获取商品详情（用于按需加载）
function getGroupItemDetails(templateGroupId) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/getGroupItemDetails',
    method: 'get',
    params: {
      templateGroupId: templateGroupId
    }
  });
}

// 删除分组列表
function deleteTemplateDishGroup(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/deleteTemplateDishGroup?id=' + id,
    method: 'get'
  });
}

// 添加分组列表
function addTemplateDishGroup(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/addTemplateDishGroup',
    method: 'post',
    data: data
  });
}
function batchAddTemplateDishGroup(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/batchAddTemplateDishGroup',
    method: 'post',
    data: data
  });
}

// 获取模板关联的分组列表
function getTemplateDishGroup(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/getTemplateDishGroup',
    method: 'get',
    params: query
  });
}

// 列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/page',
    method: 'get',
    params: query
  });
}

// 保存
function save(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/saveXyMenuTemplate',
    method: 'post',
    data: data
  });
}

// 删除
function deleteById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/deleteXyMenuTemplate?id=' + id,
    method: 'get'
  });
}

// 通过id等级信息
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/' + id,
    method: 'get'
  });
}

// 应用草稿
function applyDraft(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/applyDraft?id=' + id,
    method: 'get'
  });
}

// 生成草稿
function copyTemplateDraft(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/copyTemplateDraft?id=' + id,
    method: 'get'
  });
}

// 复制模板
function copyTemplate(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/copyTemplate?id=' + id,
    method: 'get'
  });
}

// 生成菜单模板预览二维码
function generateMenuPreviewQrCode(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/generatePreviewQrCode',
    method: 'post',
    data: data
  });
}

// 批量下载所有门店预览码（打包成zip）
function downloadAllStoreQrCodes(query) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/downloadAllStoreQrCodes',
    method: 'get',
    params: query,
    responseType: 'blob'
  });
}
// ============ 分组排序相关 API ============

// 根据模板ID和场景查询配置列表
function getGroupSortList(templateId, scene) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplateGroupSort/listByTemplate',
    method: 'get',
    params: {
      templateId: templateId,
      scene: scene
    }
  });
}

// 获取或初始化指定模板和场景的默认排序配置
function getDefaultGroupSort(templateId, scene) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplateGroupSort/getDefaultSort',
    method: 'get',
    params: {
      templateId: templateId,
      scene: scene
    }
  });
}

// 创建分组排序配置
function createGroupSortConfig(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplateGroupSort/createWithDetails',
    method: 'post',
    data: data
  });
}

// 更新分组排序配置
function updateGroupSortConfig(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplateGroupSort/updateConfig',
    method: 'put',
    data: data
  });
}

// 删除分组排序配置
function deleteGroupSortConfig(id) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplateGroupSort/deleteWithDetails/' + id,
    method: 'delete'
  });
}

// 保存分组排序
function saveGroupSortConfig(data) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplateGroupSort/saveGroupSort',
    method: 'post',
    data: data
  });
}

// 一键下发 - 同步模板状态到门店
function syncStatusToStores(templateId) {
  return (0, _requestPIM.default)({
    url: '/xyMenuTemplate/syncStatusToStores',
    method: 'get',
    params: {
      templateId: templateId
    }
  });
}